<template>
  <div class="container mx-auto p-6">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">

      <!-- Panel de Presupuestos -->
      <div class="bg-white rounded-xl shadow-lg overflow-hidden">
        <div class="bg-sky-700 text-white px-6 py-4">
          <h2 class="text-xl font-semibold">Presupuestos</h2>
        </div>
        <div class="p-4 max-h-[calc(100vh-200px)] overflow-y-auto">
          <div class="space-y-3">
            <div v-for="budget in budgets" 
                 :key="budget.id" 
                 class="bg-gray-50 hover:bg-gray-100 transition-colors duration-200 rounded-lg p-3">
              <order-card :order="budget" />
            </div>
          </div>
        </div>
      </div>

      <!-- Panel de Ventas -->
      <div class="bg-white rounded-xl shadow-lg overflow-hidden">
        <div class="bg-sky-700 text-white px-6 py-4">
          <h2 class="text-xl font-semibold">Ventas</h2>
        </div>
        <div class="p-4 max-h-[calc(100vh-200px)] overflow-y-auto">
          <div class="grid grid-cols-1 gap-3">
            <div v-for="storer in storers" 
                 :key="storer.id" 
                 class="bg-gray-50 hover:bg-gray-100 transition-colors duration-200 rounded-lg p-3">
              <order-card :order="storer" />
            </div>
          </div>
        </div>
      </div>

      <!-- Paneles comentados mantenidos para referencia futura -->
      <!-- Panel de Finanzas -->
      <!-- <div class="bg-white rounded-xl shadow-lg overflow-hidden">
        <div class="bg-sky-700 text-white px-6 py-4">
          <h2 class="text-xl font-semibold">Finanzas</h2>
        </div>
        <div class="p-4 max-h-[calc(100vh-200px)] overflow-y-auto">
          <div class="space-y-3">
            <div v-for="request in requests" 
                 :key="request.id" 
                 class="bg-gray-50 hover:bg-gray-100 transition-colors duration-200 rounded-lg p-3">
              <order-card :order="request" />
            </div>
          </div>
        </div>
      </div> -->

      <!-- Panel de Finalizados -->
      <!-- <div class="bg-white rounded-xl shadow-lg overflow-hidden">
        <div class="bg-sky-700 text-white px-6 py-4">
          <h2 class="text-xl font-semibold">Finalizada</h2>
        </div>
        <div class="p-4 max-h-[calc(100vh-200px)] overflow-y-auto">
          <div class="space-y-3">
            <div v-for="done in dones" 
                 :key="done.id" 
                 class="bg-gray-50 hover:bg-gray-100 transition-colors duration-200 rounded-lg p-3">
              <order-card :order="done" />
            </div>
          </div>
        </div>
      </div> -->

    </div>
  </div>
</template>

<script>
import Layout from '../../Shared/Layout.vue'
import LayoutFullVue from '../../Shared/LayoutFull.vue'
import OrderCard from './OrderCard.vue'

export default {
  name: 'Overview',
  
  components: { 
    OrderCard 
  },
  
  layout: LayoutFullVue,
  
  props: {
    budgets: {
      type: Object,
      required: true
    },
    storers: {
      type: Object,
      required: true
    },
    requests: {
      type: Object,
      default: () => ({})
    },
    dones: {
      type: Object,
      default: () => ({})
    }
  },

  mounted() {
    this.initializeAutoRefresh()
  },

  methods: {
    initializeAutoRefresh() {
      setInterval(() => {
        window.location.reload()
      }, 30000)
    }
  }
}
</script>